import tenantClient from '@/axiosClients/tenantClient';

const getTenantById = (tenantId) => {
    return tenantClient.get(`/tenants/${tenantId}`)
}

const updateTenant = (id, data) => {
    return tenantClient.put(`/tenants/${id}`, data)
}

export default {
    getTenantById,
    updateTenant
};
